// Libraries
import { useCallback, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
// Actions
import ShowNotification from '../../actions/notification';
// Services
import { getPatientCareTeam } from '../../services/patient';
// Constants
import { NOTIFICATION_TYPE } from '../../constants/constants';


const useLoadCareTeam = ({ patientId }) => {
  const [careTeam, setCareTeam] = useState([]);
  const dispatch = useDispatch();
  const showNotification = notificationData => dispatch(ShowNotification(notificationData));

  const fetchCareTeam = useCallback(async () => {
    const getPatientCareTeamRequest = getPatientCareTeam(patientId);
    const getPatientCareTeamPromise = getPatientCareTeamRequest.promise;
    try {
      const data = await getPatientCareTeamPromise;
      setCareTeam(data);
    } catch (error) {
      if (error.isCanceled || error.status === 401 || error.status === 403) {
        return;
      }
      showNotification({
        message: 'An error occurred while attempting to load careTeam.',
        autoHide: true,
        notificationType: NOTIFICATION_TYPE.ERROR,
      });
    }
  }, [patientId]);

  useEffect(() => { fetchCareTeam(); }, [fetchCareTeam]);

  return { careTeam, refetch: fetchCareTeam };
};

export default useLoadCareTeam;
